export const useGetParams = () => {
  const searchParams = new URLSearchParams(window.location.search);

  const getDefaultValue = (value, defaultValue) => {
    if (value === '0') {
      return '';
    } else if (value) {
      return value;
    } else return defaultValue;
  };

  return {
    user: searchParams.get('user') || '',

    bg: searchParams.get('bg') || '1',

    bgVideoQuestion: searchParams.get('bgVideoQuestion') || '1',
    bgPosterQuestion: searchParams.get('bgPosterQuestion') || null,

    bgImgQuestion: searchParams.get('bgImgQuestion') || null,

    title: getDefaultValue(
      searchParams.get('title'),
      'На какого персонажа вы похожи?'
    ),
    titleFontSize: searchParams.get('titleFontSize') || '14',
  };
};
